import { List, Map, fromJS } from 'immutable';

import PostcoderOption from 'models/PostcoderOptionModel';

import { postcoderAddress, postcoderResetSearch, postcoderSearch } from './types';

import { combineReducerArray } from '../utils/helpers';

export * from './actions';

const initialState = fromJS({
  address: {
    data: Map(),
    network: {
      loading: false,
      error: false,
    },
  },
  network: {
    loading: false,
    error: false,
  },
  options: List(),
});

const postcoderReducerObject = {
  [postcoderAddress.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['address', 'network', 'loading'], true)
        .setIn(['address', 'network', 'error'], false),
    ),
  [postcoderAddress.success]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['address', 'network', 'loading'], false)
        .setIn(['address', 'network', 'error'], false),
    ),
  [postcoderAddress.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['address', 'network', 'loading'], false)
        .setIn(['address', 'network', 'error'], true),
    ),

  [postcoderSearch.request]: (state) =>
    state.withMutations((currentState) =>
      currentState.setIn(['network', 'loading'], true).setIn(['network', 'error'], false),
    ),
  [postcoderSearch.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .setIn(['options'], List(action.response.map(PostcoderOption.deserialize))),
    ),
  [postcoderSearch.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState.setIn(['network', 'loading'], false).setIn(['network', 'error'], true),
    ),

  [postcoderResetSearch]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .setIn(['options'], List()),
    ),
};

export default combineReducerArray(initialState, [postcoderReducerObject]);
